/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'voucher-config': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M964.655 201.31c-13.964 44.217-53.528 76.8-98.91 84.945v612.072c10.473-13.963 18.619-29.09 24.437-46.545l128-495.71c16.29-62.836 1.163-126.836-53.527-154.763zm-786.619 97.745c-46.545-9.31-87.272-41.891-100.072-88.437-57.019 15.127-89.6 72.146-73.31 128L162.91 892.51c3.491 13.964 10.473 25.6 18.618 36.073-1.163-5.818-2.327-12.8-2.327-18.618v-610.91zm559.71-256h-64c-18.619 66.327-80.291 115.2-153.6 115.2-73.31 0-134.982-48.873-153.6-115.2h-64c-40.728 0-73.31 32.581-73.31 72.145v793.6c0 39.564 32.582 72.145 73.31 72.145h64c18.618-66.327 80.29-115.2 153.6-115.2 73.309 0 134.981 48.873 153.6 115.2h64c40.727 0 72.145-32.581 72.145-72.145V115.2c1.164-39.564-31.418-72.145-72.146-72.145z"/>'
  }
})
